export const defaultContent = {
    // Base
    companyName: "",
    ceoName: "",
    mail: "",
    phoneNumber: "",
    // Sections
    showSections: [],
    // Layout
    logo: "",
    logoLinkUrl: "",
    // Header
    headerTitle: "",
    headerCtaText: "",
    headerCtaUrl: "",
    headerImage: "",
    headerImagePosition: "",
    headerThumbnail: "",
    // Footer
    footerLogo: "",
    footerLogoLinkUrl: "",
    slogan: "",
    copyrightAdditionalText: "",
    footerContact: [
        {
            text: "",
            iconLibrary: "",
            iconName: "",
        },
    ],
    footerBottomBarLinks: [
        {
            title: "",
            routeID: "",
        },
    ],
    // Content
    infoText: "",
    // Services
    servicesTitle: "",
    servicesDescription: "",
    // Tours
    toursTitle: "",
    toursDescription: "",
    toursNoticeText: "",
    toursNoticeLegalText: "",
    // Gallery
    galleryTitle: "",
    // Extras
    extrasTitle: "",
    extrasContent: [
        {
            title: "",
            subtitle: "",
            iconLibrary: "",
            iconName: "",
            description: "",
        },
    ],
    // Partner
    partnerTitle: "",
    partnerDescription: "",
    partnerContent: [
        {
            title: "",
            description: "",
            iconUrl: "",
            ctaText: "",
            ctaUrl: "",
        },
    ],
    // FAQ
    faqTitle: "",
    faqCtaText: "",
    faqCtaUrl: "",
    faqFooterText: "",
    // Subpages (data protection)
    dataProtectionContent: "",
    // Subpages (imprint)
    imprintContent: "",
    // Subpages (about)
    subpageAboutInfoText: "",
    subpageAboutContent: [
        {
            title: "",
            iconLibrary: "",
            iconName: "",
            description: "",
        },
    ],
    // Collections
    services: [
        {
            title: "",
            subtitle: "",
            description: "",
            ctaText: "",
            ctaUrl: "",
            image: "",
        },
    ],
    tours: [
        {
            title: "",
            description: "",
            linkUrl: "",
            image: "",
        },
    ],
    gallery: [
        {
            title: "",
            cols: "",
            rows: "",
            position: "",
            image: "",
        },
    ],
    faq: [
        {
            title: "",
            description: "",
        },
    ],
};
